var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header__dropdown-container-inner" },
    [
      _vm.block.link_list_active
        ? _c(
            "div",
            {
              staticClass:
                "header__dropdown-container-links-large-image-container"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "header__dropdown-container-inner-featured-menu-links-container"
                },
                [
                  _vm.block.featured_link_list_active
                    ? _c(
                        "div",
                        { staticClass: "header__dropdown-side-list" },
                        _vm._l(_vm.block.featured_link_list, function(
                          link,
                          index
                        ) {
                          return _c(
                            "ul",
                            { staticClass: "header__dropdown-list" },
                            [
                              _vm.block.title
                                ? _c("li", [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "header__dropdown-featured-link",
                                        attrs: { href: link.url }
                                      },
                                      [
                                        _vm._v(_vm._s(link.title)),
                                        _c("icon", {
                                          staticClass:
                                            "mobile-header-menu-image-link-arrow",
                                          attrs: {
                                            name: "arrow_long_right",
                                            size: "24px"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass:
                        "header__dropdown-lists-container header__dropdown-list-menu-links-main-container"
                    },
                    _vm._l(_vm.block.link_list, function(link, index) {
                      return _c(
                        "ul",
                        {
                          staticClass:
                            "header__dropdown-list header__dropdown-list-menu-links-container"
                        },
                        [
                          _c(
                            "li",
                            {
                              staticClass:
                                "header__dropdown-list-links-image-container"
                            },
                            [
                              link.image
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mobile-header-dropdown-list-image-container"
                                    },
                                    [
                                      _c("img", {
                                        staticClass:
                                          "mobile-header-dropdown-list-image",
                                        attrs: { src: link.image }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header-dropdown-list-links-container"
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "header__dropdown-list-title",
                                      attrs: { href: link.url }
                                    },
                                    [_vm._v(_vm._s(link.title))]
                                  ),
                                  _vm._l(link.children, function(
                                    child_link,
                                    index
                                  ) {
                                    return _c("ul", [
                                      _c(
                                        "li",
                                        {
                                          staticClass:
                                            "header__dropdown-list-item"
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "header__dropdown-link",
                                              attrs: { href: child_link.url }
                                            },
                                            [_vm._v(_vm._s(child_link.title))]
                                          )
                                        ]
                                      )
                                    ])
                                  })
                                ],
                                2
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "header__dropdown-images--large-image-inner-container"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "header__dropdown-images-large-image clip-transition"
                    },
                    [
                      _c("img", {
                        staticClass: "header__dropdown-large-image",
                        attrs: {
                          src: _vm.block.large_image,
                          alt: _vm.block.large_image_title
                        }
                      })
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "header__dropdown-images--large-image-description-container"
                    },
                    [
                      _vm.block.large_image_title
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "header__dropdown-images--large-image-title"
                            },
                            [_vm._v(_vm._s(_vm.block.large_image_title))]
                          )
                        : _vm._e(),
                      _vm.block.large_image_description
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "header__dropdown-images--large-image-description",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.block.large_image_description
                                )
                              }
                            },
                            [_vm._v(_vm._s(_vm.block.large_image_description))]
                          )
                        : _vm._e(),
                      _vm.block.large_image_link
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "header__dropdown-images--large-image-link",
                              attrs: { href: _vm.block.large_image_link }
                            },
                            [
                              _vm._v(_vm._s(_vm.block.large_image_link_text)),
                              _c("icon", {
                                staticClass:
                                  "menu-image-link-arrow fill-brand-primary",
                                attrs: {
                                  name: "arrow_long_right",
                                  size: "24px"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ]
              )
            ]
          )
        : _c(
            "div",
            { staticClass: "header__dropdown-images--large-image-container" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "header__dropdown-images--large-image-inner-container"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "header__dropdown-images-large-image clip-transition"
                    },
                    [
                      _c("img", {
                        staticClass: "header__dropdown-large-image",
                        attrs: {
                          src: _vm.block.large_image,
                          alt: _vm.block.large_image_title
                        }
                      })
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "header__dropdown-images--large-image-description-container"
                    },
                    [
                      _vm.block.large_image_title
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "header__dropdown-images--large-image-title"
                            },
                            [_vm._v(_vm._s(_vm.block.large_image_title))]
                          )
                        : _vm._e(),
                      _vm.block.large_image_description
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "header__dropdown-images--large-image-description",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.block.large_image_description
                                )
                              }
                            },
                            [_vm._v(_vm._s(_vm.block.large_image_description))]
                          )
                        : _vm._e(),
                      _vm.block.large_image_link
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "header__dropdown-images--large-image-link",
                              attrs: { href: _vm.block.large_image_link }
                            },
                            [
                              _vm._v(_vm._s(_vm.block.large_image_link_text)),
                              _c("icon", {
                                staticClass:
                                  "menu-image-link-arrow fill-brand-primary",
                                attrs: {
                                  name: "arrow_long_right",
                                  size: "24px"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ]
              )
            ]
          ),
      _vm.block.url
        ? _c(
            "v-link",
            {
              staticClass: "header__menu-main-inner-link",
              attrs: { secondary: "", href: _vm.block.url }
            },
            [_vm._v("  Shop All")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }